import { merge } from '../../../helper';

import exLanguage from '../../../language';
import * as exModal from '../../../components/modal';
import type { IModalConfig } from '../../../components/modal/types';

import exCreateDropzone, { type ICreateConfig } from '../dropzone/create';

// ----------------------------------------------------------------------------

export type TypeModalUploadConfig = {
    modal?: IModalConfig;
    upload?: ICreateConfig;
    fnCreate?: (config: ICreateConfig) => Record<string, any>;
};

// ----------------------------------------------------------------------------

function start(config: TypeModalUploadConfig): Record<string, any> {
    const defConfig: TypeModalUploadConfig = {};
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const build: Record<string, any> = {};

    // ------------------------------------------------------------------------

    // Create element (modal)
    const modal = exModal.start({
        merge: defConfig.modal,
        attr: {
            id: 'upload-modal',
        },
        modalDialog: {
            class: {
                add: 'modal-xl',
            },
        },
        modalHeader: {
            icon: 'fa-solid fa-upload',
            title: {
                html: exLanguage.line('general.import'),
            },
        },
        buttons: [
            {
                class: {
                    new: 'btn btn-primary',
                },
                attr: {
                    disabled: '',
                },
                html: exLanguage.line('general.import'),
            },
            {
                html: exLanguage.line('general.cancel'),
            },
        ],
        backdrop: 'static',
        destroy: true,
    });
    build.element = modal.element;
    build.modal = modal;

    // ------------------------------------------------------------------------

    // Create element (upload)
    const createFn = defConfig.fnCreate ?? exCreateDropzone;
    const upload = createFn({
        merge: defConfig.upload,
    });
    modal.child(upload.element);
    build.upload = upload;

    // ------------------------------------------------------------------------

    // Return
    return build;
}

// ----------------------------------------------------------------------------

export { start };
